// directives/draggable.js
const DRAG_MIME = 'text/plain';

function bindDraggable(el, binding) {
  unbindDraggable(el);

  const enable = binding.value !== undefined && binding.value !== null && binding.value !== '';
  el.setAttribute('draggable', !!enable);
  if (!enable) {
    return;
  }

  el._dragStart = (event) => {
    el.classList.add('ugo-draggable');
    event.dataTransfer.setData(DRAG_MIME, String(binding.value));
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.dropEffect = 'move';
  };

  el._dragEnd = () => {
    el.classList.remove('ugo-draggable');
  };

  el.addEventListener('dragstart', el._dragStart);
  el.addEventListener('dragend', el._dragEnd);
}

function unbindDraggable(el) {
  if (el._dragStart) {
    el.removeEventListener('dragstart', el._dragStart);
    el.removeEventListener('dragend', el._dragEnd);
  }
  el.classList.remove('ugo-draggable');
  delete el._dragStart;
  delete el._dragEnd;
}

export default {
  bind(el, binding) {
    bindDraggable(el, binding);
  },
  update(el, binding) {
    bindDraggable(el, binding);
  },
  unbind(el) {
    unbindDraggable(el);
  },
};
